import React from 'react';
import { Link } from 'react-router-dom';
import './Inner.css';

const team = [
  { name: 'Aryan Mehta', role: 'CEO & Co-founder',  avatar: 'AM', bg: 'linear-gradient(135deg,#9747FF,#E040FB)', bio: '10+ years in product and engineering. Previously at Razorpay and Freshworks.' },
  { name: 'Priya Nair',  role: 'CTO & Co-founder',  avatar: 'PN', bg: 'linear-gradient(135deg,#0AC5A8,#2563EB)', bio: 'Full-stack architect. Ex-Google, open-source contributor with 3K+ GitHub stars.' },
  { name: 'Rahul Desai', role: 'Head of AI',         avatar: 'RD', bg: 'linear-gradient(135deg,#FF6B35,#F7B731)', bio: 'ML researcher turned builder. 5 years building LLM products in production.' },
  { name: 'Sneha Iyer',  role: 'Head of Growth',     avatar: 'SI', bg: 'linear-gradient(135deg,#DB2777,#9747FF)', bio: 'Growth hacker with 8 years driving B2B pipeline for SaaS companies.' },
];

const values = [
  { icon: '🎯', title: 'Outcome-first',    desc: "We define success by your business results, not by deliverables shipped." },
  { icon: '🔍', title: 'Radical honesty',  desc: "We tell you what we think, not what you want to hear — including when we're not the right fit." },
  { icon: '⚡', title: 'Bias to action',   desc: "We move fast, iterate in public, and learn from real users — not assumptions." },
  { icon: '🤝', title: 'Deep partnership', desc: "We embed with your team. Your problem is our problem, until it's solved." },
];

const storyStats = [
  ['2018',   'Founded'],
  ['28',     'Team members'],
  ['200+',   'Projects shipped'],
  ['₹50Cr+', 'Revenue generated for clients'],
];

export function About() {
  return (
    <div>
      <section className="page-hero" style={{ textAlign: 'center' }}>
        <div className="ph-orb ph-orb-1" />
        <div className="ph-orb ph-orb-2" />
        <div className="container page-hero-inner">
          <div className="badge"><div className="badge-dot">✦</div>Our story</div>
          <h1 className="ph-title">
            We build products that<br /><span className="grad-text">actually ship</span>
          </h1>
          <p className="ph-sub">
            NextGenHub Life was founded in 2018 by engineers frustrated with agencies that overpromise and underdeliver. We set out to build a different kind of digital partner.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="section">
        <div className="container">
          <div className="about-story">
            <div className="about-story-text">
              <h2 className="svc-section-head">Why we exist</h2>
              <p className="svc-detail-para">
                Most digital agencies measure success by hours billed or deliverables shipped. We measure it by one thing: did your business grow?
              </p>
              <p className="svc-detail-para">
                We started NextGenHub Life because we'd seen too many companies invest heavily in technology and marketing that didn't move the needle — not because the work was bad, but because the work wasn't connected to the right outcomes.
              </p>
              <p className="svc-detail-para">
                Today we're a team of 28 engineers, designers, and growth strategists working across web, mobile, AI, and marketing — always with the same goal: make the number go up.
              </p>
            </div>
            <div className="about-story-stats">
              {storyStats.map(([n, l]) => (
                <div key={l} className="ast-card">
                  <div className="ast-num grad-text">{n}</div>
                  <div className="ast-label">{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section" style={{ background: 'var(--gray-50)', borderTop: '1px solid var(--gray-200)', borderBottom: '1px solid var(--gray-200)' }}>
        <div className="container">
          <div className="section-center" style={{ marginBottom: 48 }}>
            <div className="s-tag">Our values</div>
            <h2 className="s-head">What we stand for</h2>
          </div>
          <div className="about-values">
            {values.map(v => (
              <div key={v.title} className="av-card">
                <div className="av-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section">
        <div className="container">
          <div className="section-center" style={{ marginBottom: 48 }}>
            <div className="s-tag">The team</div>
            <h2 className="s-head">People behind the work</h2>
          </div>
          <div className="team-grid">
            {team.map(m => (
              <div key={m.name} className="team-card">
                <div className="team-avatar" style={{ background: m.bg }}>{m.avatar}</div>
                <h3>{m.name}</h3>
                <div className="team-role">{m.role}</div>
                <p>{m.bio}</p>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 48 }}>
            <Link to="/get-quote" className="btn-grad">Work with our team →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
